import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampaignService } from '@app/services/campaigns/campaign.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';



@Component({
  selector: 'app-failed-mails',
  standalone: false,
  templateUrl: './failed-mails.component.html',
  styleUrl: './failed-mails.component.css'
})
export class FailedMailsComponent {
  failedMails: any[] = [];
  campaignId: string = "";
 userid: number;
  constructor(private campaignService: CampaignService, private activatedRoute: ActivatedRoute, permissionService: PermissionsService) {
    this.userid = permissionService.userid;
    this.activatedRoute.params.subscribe(params => {
      this.campaignId = params['id'];
      this.campaignService.getFailedMails(this.campaignId).subscribe((mails: any[]) => {
        
        this.failedMails = mails;
      });
    });
  }
  }
